<template>
  <template v-if="deviceMode != 'desktop'">
    <div>
      <ul
        class="nav nav-pills mb-3"
        :id="mode == 'filter' ? 'filter-pills-tab' : 'pills-tab'"
        role="tablist"
      >
        <li
          class="nav-item"
          role="presentation"
          v-for="(item, idx) in locationObj"
          :key="idx"
        >
          <button
            class="nav-link"
            :class="idx == 0 ? 'active' : ''"
            :id="'pills-' + idx + filterIdx + '-tab'"
            data-bs-toggle="pill"
            :data-bs-target="
              mode == 'filter'
                ? '#filter-pills-' + idx + filterIdx
                : '#pills-' + idx + filterIdx
            "
            type="button"
            role="tab"
          >
            {{ item.name }}
          </button>
        </li>
        <li class="nav-item" role="presentation" v-if="mode == 'filter'">
          <button class="nav-link" @click.stop="search('location', '全部')">
            所有地區
          </button>
        </li>
      </ul>
      <div class="d-flex align-items-start">
        <div
          class="tab-content"
          :id="
            mode == 'filter' ? 'filter-pills-tabContent' : 'pills-tabContent'
          "
          style="background: #fff !important"
        >
          <div
            class="tab-pane fade show tabcontent"
            :id="
              mode == 'filter'
                ? 'filter-pills-' + idx + filterIdx
                : 'pills-' + idx + filterIdx
            "
            role="tabpanel"
            v-for="(item, idx) in locationObj"
            :key="idx"
            :class="idx == 0 ? 'active' : ''"
          >
            <table
              class="location_table"
              style="border: none"
              v-if="item.countries.length > 0"
            >
              <tr>
                <td @click.stop="search('location', item.name)">
                  全{{ item.name }}
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr v-for="i in item.countries" :key="i.id">
                <td width="100px" @click.stop="search('location', i.name)">
                  {{ i.name }}
                </td>
                <td v-if="i.cities.length > 0">
                  <ul class="flex-container">
                    <li
                      class="flex-item"
                      v-for="j in i.cities"
                      :key="j.id"
                      @click.stop="search('location', j.name)"
                    >
                      {{ j.name }}
                    </li>
                  </ul>
                </td>
                <td v-else>&nbsp;</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="d-flex align-items-start">
      <div
        class="nav flex-column nav-pills me-3 tab"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <button
          class="nav-link tabs"
          :id="'v-pills-' + idx + filterIdx + '-tab'"
          data-bs-toggle="pill"
          :data-bs-target="'#v-pills-' + idx + filterIdx"
          type="button"
          role="tab"
          v-for="(item, idx) in locationObj"
          :class="idx == 0 ? 'active' : ''"
          :key="idx"
        >
          {{ item.name }}
        </button>
        <button
          v-if="mode == 'filter'"
          @click.stop="search('location', '全部')"
        >
          所有地區
        </button>
      </div>
      <div
        class="tab-content"
        id="v-pills-tabContent"
        style="background: #fff !important"
      >
        <div
          class="tab-pane fade show tabcontent"
          :id="'v-pills-' + idx + filterIdx"
          role="tabpanel"
          v-for="(item, idx) in locationObj"
          :key="idx"
          :class="idx == 0 ? 'active' : ''"
        >
          <table
            class="location_table"
            style="border: none"
            v-if="item.countries.length > 0"
          >
            <tr>
              <td @click.stop="search('location', item.name)">
                全{{ item.name }}
              </td>
              <td>&nbsp;</td>
            </tr>
            <tr v-for="i in item.countries" :key="i.id">
              <td width="100px" @click.stop="search('location', i.name)">
                {{ i.name }}
              </td>
              <td v-if="i.cities.length > 0">
                <ul class="flex-container">
                  <li
                    class="flex-item"
                    v-for="j in i.cities"
                    :key="j.id"
                    @click.stop="search('location', j.name)"
                  >
                    {{ j.name }}
                  </li>
                </ul>
              </td>
              <td v-else>&nbsp;</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import ApiService from "@/services/ApiService.js";
import router from "@/router";
import useEventBus from "@/config/eventBus";
import { useStore } from "vuex";

export default {
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const filterIdx = ref(0);
    const store = useStore();
    const locationObj = ref([]);
    const eventBus = useEventBus();
    const search = (scope, name) => {
      eventBus.emit("closeSearchBox");
      eventBus.emit("hideSearchBar");
      eventBus.emit("hideBottomOverlay");
      if (props.mode == "search") router.push("/search/" + scope + "/" + name);
      else if (props.mode == "filter")
        eventBus.emit("filterProductByLocation", name);
    };
    const locations = computed(() => store.getters["location/locations"]);
    const deviceMode = computed(() => store.getters["device/mode"]);

    onMounted(() => {
      if (props.mode == "filter") filterIdx.value = 666;
      setTimeout(() => {
        if (props.categoryId === 0) {
          locationObj.value = locations.value;
        } else {
          ApiService.getLocation(props.categoryId).then((res) => {
            if (res.masterProductLocationResponse.length > 0) {
              res.masterProductLocationResponse.forEach((x) => {
                if (x.flagShow === "Y") {
                  if (x.parentId < 0) {
                    locationObj.value.push({
                      id: x.id,
                      name: x.name.trim(),
                      countries: [],
                    });
                  } else {
                    if (locationObj.value.length > 0) {
                      locationObj.value.forEach((y) => {
                        if (x.parentId === y.id) {
                          y.countries.push({
                            id: x.id,
                            name: x.name.trim(),
                            cities: [],
                          });
                        }
                        y.countries.forEach((z) => {
                          if (x.parentId === z.id) {
                            z.cities.push({
                              id: x.id,
                              name: x.name.trim(),
                            });
                          }
                        });
                      });
                    }
                  }
                }
              });
            }
          });
        }
      }, 500);
    });

    return {
      locationObj,
      search,
      deviceMode,
      filterIdx,
    };
  },
};
</script>
